import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '@shared/utils/base-auth';
import { AppConfig, ProductionTypes } from '@shared/utils/app-config';

@Pipe({
  name: 'userRoleToString',
  standalone: false,
})
export class UserRolePipe implements PipeTransform {
  constructor(private appConfig: AppConfig) {}
  transform(role: UserRole): string {
    switch (role) {
      case UserRole.Guest:
        return 'Guest';
      case UserRole.User:
        return 'User';
      case UserRole.Supervisor:
        return 'Supervisor';
      case UserRole.Commander:
        return this.appConfig.productionType === ProductionTypes.isMining || this.appConfig.productionType === ProductionTypes.isIndustrialCam ? 'User' : 'Commander';
      case UserRole.HRAdmin:
        return 'IT Staff';
      case UserRole.SuperAdmin:
        return 'Super Administrator';
      case UserRole.Kiosk:
        return 'Kiosk';
      case UserRole.Prosecutor:
        return 'Prosecutor';
      case UserRole.NonInteractiveUser:
        return 'Non Interactive User';
    }
  }
}
